import { render, staticRenderFns } from "./NotesModal.vue?vue&type=template&id=23eb09a9&scoped=true"
import script from "./NotesModal.vue?vue&type=script&lang=ts"
export * from "./NotesModal.vue?vue&type=script&lang=ts"
import style0 from "./NotesModal.vue?vue&type=style&index=0&id=23eb09a9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eb09a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23eb09a9')) {
      api.createRecord('23eb09a9', component.options)
    } else {
      api.reload('23eb09a9', component.options)
    }
    module.hot.accept("./NotesModal.vue?vue&type=template&id=23eb09a9&scoped=true", function () {
      api.rerender('23eb09a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/activities/NotesModal.vue"
export default component.exports